import { useSelectedNumberByVariableKey } from '@k3/core'
import { Helper } from '../../../../classes/helper'
import { useMontage } from '../../../../context/montage.context'

export interface RulerInformation {
  name: string
  length: number
  startPoint: number[]
  endPoint: number[]
  direction: 'x' | 'y' | 'z'
  textPosition: number[]
  textRotation: number[]
}

export const rulers = () => {
  const { roof } = useMontage()
  const coverStart = Helper.coverStartPosition(roof.attachment)
  const width = useSelectedNumberByVariableKey('width') / 100
  const height = useSelectedNumberByVariableKey('height') / 100
  const tiefe = useSelectedNumberByVariableKey('depth') / 100
  const angel = useSelectedNumberByVariableKey('angle')
  const toRadians = (degrees: number) => {
    return degrees * (Math.PI / 180)
  }

  const calcGegenkathete = (alpha: number, ankathete: number) => {
    return (ankathete * Math.sin(toRadians(alpha))) / Math.cos(toRadians(alpha))
  }

  return [
    {
      name: 'breite',
      length: width * 100,
      startPoint: [-width / 2, 0.05, tiefe + 0.5 + coverStart],
      endPoint: [width / 2, 0.05, tiefe + 0.5 + coverStart],
      direction: 'x',
      textPosition: [0, 0.05, tiefe + 0.5 + coverStart],
      textRotation: [-Math.PI / 2, 0, 0],
    },
    {
      name: 'höhe1',
      length: height * 100,
      startPoint: [-width / 2 - 0.5, 0.01, 0.1 + coverStart],
      endPoint: [-width / 2 - 0.5, height + 0.04, 0.1 + coverStart],
      direction: 'y',
      textPosition: [-width / 2 - 0.5, height / 2 + 0.02, 0.1 + coverStart],
      textRotation: [0, 0, 0],
    },
    {
      name: 'höheVorne',
      length: (height * 100 - calcGegenkathete(angel, tiefe * 100)).toFixed(2),
      startPoint: [-width / 2 - 0.5, 0.01, tiefe + 0.08 + coverStart],
      endPoint: [
        -width / 2 - 0.5,
        height - calcGegenkathete(angel, tiefe) + 0.04,
        tiefe + 0.08 + coverStart,
      ],
      direction: 'y',
      textPosition: [
        -width / 2 - 0.5,
        (height - calcGegenkathete(angel, tiefe) + 0.04) / 2,
        tiefe + 0.08 + coverStart,
      ],
      textRotation: [0, 0, 0],
    },
    {
      name: 'tiefe',
      length: tiefe * 100,
      startPoint: [width / 2 + 0.5, 0.05, coverStart],
      endPoint: [width / 2 + 0.5, 0.05, tiefe + 0.08 + coverStart],
      rotate: [0, Math.PI / 2, 0],
      direction: 'z',
      textPosition: [width / 2 + 0.5, 0.05, (tiefe + 0.08 + coverStart) / 2],
      textRotation: [Math.PI / 2, 0, -Math.PI / 2],
    },
  ] as RulerInformation[]
}
